/**
 * sc-magsafe-price.js — Stylized MagSafe option price
 *
 * Replaces the Customily-rendered `(+ $4.99)` on "Make It MagSafe" label with
 * compare-at + current price pair matching Shipping Protection visual
 * (`$8.99` strikethrough + `$4.99` bold navy).
 *
 * Vanilla JS, no deps. Safe on pages without MagSafe option (self-bails).
 */
(function () {
  'use strict';

  var LABEL_SELECTOR = '.cl-has-checkbox .cl-checkbox-inner-label';
  var PRICE_REGEX = /\(\+\s*\$[\d.]+\)/;
  var COMPARE_AT = '$8.99';
  var CURRENT = '$4.99';
  var OBSERVER_TIMEOUT_MS = 15000;

  function render(label) {
    if (!label || label.dataset.scMsPrice === '1') return false;
    if (!PRICE_REGEX.test(label.innerHTML)) return false;
    label.innerHTML = label.innerHTML.replace(
      PRICE_REGEX,
      '<span class="sc-ms-compare">' + COMPARE_AT + '</span>' +
      '<span class="sc-ms-price">' + CURRENT + '</span>'
    );
    label.dataset.scMsPrice = '1';
    return true;
  }

  function trySetup() {
    var label = document.querySelector(LABEL_SELECTOR);
    return label ? render(label) : false;
  }

  function init() {
    if (trySetup()) return;
    var observer = new MutationObserver(function () {
      if (trySetup()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, OBSERVER_TIMEOUT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
